import { render, staticRenderFns } from "./ReferralDoctorsTable.vue?vue&type=template&id=2bcd2d5e&scoped=true&"
import script from "./ReferralDoctorsTable.vue?vue&type=script&lang=js&"
export * from "./ReferralDoctorsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReferralDoctorsTable.vue?vue&type=style&index=0&id=2bcd2d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd2d5e",
  null
  
)

export default component.exports